module.exports = __webpack_public_path__ + "static/inpay_logo-178e92633d731392ef258891df6468be.png";